<template>
  <div class="home">
    <Canvas />
  </div>
</template>

<script>
import Canvas from "@/components/Canvas.vue";

export default {
  name: "Home",
  components: {
    Canvas,
  },
};
</script>
